import { useQuery } from '@tanstack/react-query'
import { searchTags } from '~map-search/api/searchTags'
import { SearchTagsQueryVariables } from '~map-search/types/__generated/gql/graphql'

export function useSearchTags(variables: SearchTagsQueryVariables) {
  return useQuery({
    queryKey: ['searchTags', variables],
    queryFn: () => searchTags(variables)
  })
}
